import React from "react";
import styled from "styled-components";

const UserCard = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.2);
  }

  .user-info {
    margin-bottom: 20px;

    .user-name {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 8px;
    }

    .user-email {
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      margin-bottom: 5px;
    }

    .user-company {
      color: #4caf50;
      font-size: 14px;
      font-weight: 500;
    }

    .user-status {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 500;
      margin-top: 10px;

      &.pending {
        background: rgba(255, 193, 7, 0.2);
        color: #ffc107;
        border: 1px solid rgba(255, 193, 7, 0.3);
      }

      &.approved {
        background: rgba(76, 175, 80, 0.2);
        color: #4caf50;
        border: 1px solid rgba(76, 175, 80, 0.3);
      }

      &.rejected {
        background: rgba(244, 67, 54, 0.2);
        color: #f44336;
        border: 1px solid rgba(244, 67, 54, 0.3);
      }
    }
  }

  .card-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;

    button {
      flex: 1;
      padding: 10px 15px;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s ease;

      &.approve {
        background: #4caf50;
        color: #fff;

        &:hover {
          background: #45a049;
        }
      }

      &.reject {
        background: #f44336;
        color: #fff;

        &:hover {
          background: #da190b;
        }
      }

      &.edit {
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.2);

        &:hover {
          background: rgba(255, 255, 255, 0.2);
        }
      }
    }
  }

  /* 추가: 정보 그리드 및 배지 스타일 */
  .info-grid {
    display: grid;
    grid-template-columns: 60px 1fr;
    row-gap: 10px;
    column-gap: 16px;
    padding: 14px 16px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    margin-top: 10px;
  }

  .info-label {
    height: fit-content;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    color: #cfead3;
    background: rgba(76, 175, 80, 0.16);
    border: 1px solid rgba(76, 175, 80, 0.25);
    white-space: nowrap;
    width: fit-content;
  }

  .info-value {
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .info-muted {
    color: rgba(255, 255, 255, 0.6);
  }

  .info-desc {
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    border: 1px solid transparent;
  }

  .badge.pending {
    background: rgba(255, 193, 7, 0.16);
    color: #ffce3a;
    border-color: rgba(255, 193, 7, 0.28);
  }
  .badge.approved {
    background: rgba(76, 175, 80, 0.16);
    color: #7ad188;
    border-color: rgba(76, 175, 80, 0.28);
  }
  .badge.rejected {
    background: rgba(244, 67, 54, 0.16);
    color: #ff867f;
    border-color: rgba(244, 67, 54, 0.28);
  }

  .icon {
    opacity: 0.9;
    font-size: 14px;
  }
`;

export default function RenderCompanyCard({ company, handleApproval }) {
  
  return (
    <UserCard key={company.id}>
      <div className="user-info">
        <div className="user-name">{company.name}</div>
        <div className="user-email">{company.email}</div>
        <div className="user-company">사업자번호: {company.businessNumber}</div>
        {/* 상태 배지 */}
        <div style={{ marginTop: 10 }}>
          <span
            className={
              "badge " +
              (company.status === 3
                ? "pending"
                : company.status === 1
                ? "approved"
                : "rejected")
            }
          >
            {company.status === 3
              ? "승인 대기"
              : company.status === 1
              ? "승인됨"
              : "거절됨"}
          </span>
        </div>
      </div>

      {/* 정보 그리드 */}
      <div className="info-grid">
        <div className="info-label">주소</div>
        <div className="info-value">
          {company.address || <span className="info-muted">-</span>}
        </div>

        <div className="info-label">전화</div>
        <div className="info-value">
          {company.phone || <span className="info-muted">-</span>}
        </div>

        <div className="info-label">가입일</div>
        <div className="info-value">
          {(company.createdAt || "").toString().split("T")[0] || (
            <span className="info-muted">-</span>
          )}
        </div>

        <div className="info-label">직종</div>
        <div className="info-value info-desc">
          {company.description || (
            <span className="info-muted">등록된 설명이 없습니다.</span>
          )}
        </div>
      </div>
      {company.status === 3 && (
        <div className="card-actions">
          <button
            className="approve"
            onClick={() => handleApproval(company.id, 1, "company")}
          >
            승인
          </button>
          <button
            className="reject"
            onClick={() => handleApproval(company.id, 2, "company")}
          >
            거절
          </button>
        </div>
      )}
    </UserCard>
  );
}
